import { MAX_PAGE_SIZE } from '@debbie/common/dist/index.js';
import { toQuery } from '@debbie/common/dist/util/index.js';
import { collectionEngineV1, drainPages } from '../apis.js';
const voucherTypesAPI = collectionEngineV1('/voucher-types');
// Pages to the end so callers keep getting the full set.
export const getTypes = () => drainPages((page) => voucherTypesAPI('GET', `/?${toQuery({ page, pageSize: MAX_PAGE_SIZE })}`), MAX_PAGE_SIZE);
export const createType = (newVoucherType) => voucherTypesAPI('POST', `/`, {
    body: newVoucherType,
});
export const patchType = (voucherTypeId, patch) => voucherTypesAPI('PATCH', `/${voucherTypeId}`, {
    body: patch,
});
//# sourceMappingURL=voucher-types.js.map